const sc = process.env.VUE_APP_SC;
// const yyn = process.env.VUE_APP_YYN;
const yyn = window.location.origin;
function toCartInfo() {
  window.location.href = `${yyn}/shopCart`;
}
function toGoodInfo(id) {
  window.location.href = `${yyn}/storeGoodInfo?goodId=${id}`;
}
function toStoreInfo(id) {
  window.location.href = `${yyn}/storeInfo?shopid=${id}`;
}
function toYynIndex() {
  window.location.href = yyn;
}
function toOrder() {
  window.location.href = `${yyn}/manage?type=0`;
}
function updateTitle() {
  this.title = '订单提交';
}
function toOrderPayment(id) {
  const ifm = `${sc}payment/chectout/bkCheckout/${id}.do`;
  window.location.href = ifm;
}

export {
  toCartInfo,
  toGoodInfo,
  toStoreInfo,
  toYynIndex,
  toOrder,
  updateTitle,
  toOrderPayment,
};
